import React from "react";

const LoaderHomePd = () => {
    return (
        <>

            <div className="results">
                <div className="pd_item lzloader">
                    <div className="loaderimg">
                    </div>
                    <div className="pd_content">
                        <span className="line"></span>
                        <span className="line2"></span>
                        <span className="line2"></span>
                        <span className="line2"></span>
                        <span className="line2"></span>
                        <span className="line3"></span>
                    </div>
                </div>
                <div className="pd_item lzloader">
                    <div className="loaderimg">
                    </div>
                    <div className="pd_content">
                        <span className="line"></span>
                        <span className="line2"></span>
                        <span className="line2"></span>
                        <span className="line2"></span>
                        <span className="line2"></span>
                        <span className="line3"></span>
                    </div>
                </div>
                <div className="pd_item lzloader">
                    <div className="loaderimg">
                    </div>
                    <div className="pd_content">
                        <span className="line"></span>
                        <span className="line2"></span>
                        <span className="line2"></span>
                        <span className="line2"></span>
                        <span className="line2"></span>
                        <span className="line3"></span>
                    </div>
                </div>
                <div className="pd_item lzloader">
                    <div className="loaderimg">
                    </div>
                    <div className="pd_content">
                        <span className="line"></span>
                        <span className="line2"></span>
                        <span className="line2"></span>
                        <span className="line2"></span>
                        <span className="line2"></span>
                        <span className="line3"></span>
                    </div>
                </div>
            </div>

        </>
    )
}

export default LoaderHomePd;